

























































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';

import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import * as _ from 'lodash';
import * as routeNames from '../router-names';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import { exportOrderChange, queryOrderChangeList } from '../../../api/order-management';
import Utils from '@/utils/common';
import { receiveStatusMap } from '../../../types/order-management/dictionaries';
import moment from 'moment';

import PlateInput from '../../../components/plate-input/index.vue';

@Component({
  name: 'MoneyBoxList',
  components: {
    ParkingLotSearch,
    PlateInput
  }
})
export default class MoneyBoxList extends Mixins(TableMixin, TableWidthMixin) {
  private receiveStatusList = Utils.toLabelVal(receiveStatusMap);
  // 搜索条件
  private filterParam: any = {
    parkIds: [],
    plateHead: '', // 车牌号
    plateTail: '', // 车牌号
    paidStartTime: '',
    paidEndTime: '',
    receiveStatus: '',
    deviceId: '',
    receiveStartTime: '',
    receiveEndTime: ''
  };
  // 数据
  private tableData: any = [];
  /**
   * table loading
   */
  private tableLoading: boolean = false;

  // 生命周期
  private created() {
    this.fetchTableData();
  }

  /**
   * 搜索按钮
   */
  private search() {
    this.fetchTableData();
  }

  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkIds = [],
        plateHead,
        plateTail,
        paidStartTime = '',
        paidEndTime = '',
        receiveStatus = [],
        deviceId = '',
        receiveStartTime = '',
        receiveEndTime = ''
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行查询');
      }
      const { status, msg, code, data } = await queryOrderChangeList({
        parkIds: '' + parkIds,
        plateHead,
        plateTail,
        paidStartTime,
        paidEndTime,
        receiveStatus: '' + receiveStatus,
        deviceId,
        receiveStartTime,
        receiveEndTime,
        currPage: this.current,
        pageSize: this.pageSize
      });
      if (data) {
        const { pageSize = 0, currPage = 0, totalNum = 0, datas = [] } = data;
        this.tableData = datas;
        this.total = Number(totalNum);
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryOrderChangeList  接口调用错误');
    } finally {
      this.tableLoading = false;
    }
  }

  private async download() {
    try {
      const {
        parkIds = [],
        plateHead,
        plateTail,
        paidStartTime = '',
        paidEndTime = '',
        receiveStatus = [],
        deviceId = '',
        receiveStartTime = '',
        receiveEndTime = ''
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行导出');
      }
      await exportOrderChange(
        {
          parkIds: '' + parkIds,
          plateHead,
          plateTail,
          paidStartTime,
          paidEndTime,
          receiveStatus: '' + receiveStatus,
          deviceId,
          receiveStartTime,
          receiveEndTime
        },
        '钞箱记录'
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportOrderChange', '导出失败');
    }
  }

  private moment = moment;

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  // 支付时间变化
  private onPayTimeChange(date: any, dateString: any) {
    const [paidStartTime, paidEndTime] = dateString;
    this.filterParam.paidStartTime = paidStartTime;
    this.filterParam.paidEndTime = paidEndTime;
  }

  // 零钱领取时间变化
  private onReceiveTimeChange(date: any, dateString: any) {
    const [receiveStartTime, receiveEndTime] = dateString;
    this.filterParam.receiveStartTime = receiveStartTime;
    this.filterParam.receiveEndTime = receiveEndTime;
  }

  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 140
      },
      {
        title: '缴费终端',
        dataIndex: 'deviceName',
        width: 140
      },
      {
        title: '应付金额',
        dataIndex: 'totalAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '实缴金额',
        dataIndex: 'paidAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '找零金额',
        dataIndex: 'changeAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '零钱状态',
        dataIndex: 'receiveStatusName',
        width: 140
      },
      {
        title: '停车订单号',
        dataIndex: 'orderId',
        width: 140
      },
      {
        title: '支付时间',
        dataIndex: 'paidTime',
        width: 240
      },
      {
        title: '零钱有效期',
        dataIndex: 'expireTime',
        width: 240
      },
      {
        title: '零钱领取时间',
        dataIndex: 'receiveTime',
        width: 240
      }
    ];
  }
}
